import {useHistory} from 'react-router-dom';
import {createOrgPath} from '@core/lib/organizations';
import Designer from '@analytics/components/designer/index';
import {ManagePodlinkDomainRouteProps} from '.';

export function PodlinkPodcastDesigner({
  organization,
  podlinkDomain,
  podcasts,
  match: {
    params: {podcastId},
  },
}: ManagePodlinkDomainRouteProps & {
  match: {params: {podcastId: string}};
}) {
  const history = useHistory();

  const _podcast = podcasts.filter(({id}) => id == podcastId)[0];

  const onComplete = () => {
    history.push(
      createOrgPath(organization, `manage/podlink/${podlinkDomain.slug}`)
    );
  };

  return (
    <Designer
      organization={organization}
      podcast={_podcast}
      onCancel={onComplete}
      onSave={onComplete}
    />
  );
}
